import PageTemplate from "./PageTemplate";
import classNames from "classnames";

export default {
  render(h) {
    const FaqCollection = Object.values(this.$t("help_page.faqs"));
    const TopLinks = (
      <ul class="text-lg lg:text-xl text-blue-600 list-disc ml-5 mb-10 font-bold">
        {FaqCollection.map((faq) => (
          <li class="mb-5">
            <a href={"#" + faq.slug}>{faq.head}</a>
            <ul class="list-disc ml-10 lg:text-base text-sm">
              {faq.subcategories.map((sub) => (
                <li class="my-2 font-normal">
                  <a href={"#" + faq.slug + "-" + sub.slug}>{sub.head}</a>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    );
    const FaqItems = FaqCollection.map((faq) => (
          <div class="border-gray-400 border-t-2 py-3 lg:py-6 mt-2">
          <a name={faq.slug} class="block pt-24 -mt-24"></a>
          <p class="font-bold text-base lg:text-xl">
            {faq.head}
          </p>
          <p domPropsInnerHTML={faq.body}></p>
          {faq.type === 'plain' && faq.subcategories.map((sub) => (
          <fragment>
            <a name={faq.slug+'-'+sub.slug} class="block pt-24 -mt-24"></a>
          <p class="text-sm lg:text-base font-bold mt-6">{sub.head}</p>
          <p class="text-sm lg:text-base lg:w-9/12 py-3" domPropsInnerHTML={sub.body}></p>
          </fragment>
          )
          )}
          {faq.type === 'columns' &&
          <div
            class="flex flex-col flex-wrap lg:flex-row flex-1 text-sm lg:text-base mt-8"
          >
          {faq.subcategories.map((sub) => (
            <div class={classNames("lg:pr-6 mb-5 lg:mb-10", {'lg:w-1/3': sub.image})}>
            <a name={faq.slug+'-'+sub.slug} class="block pt-24 -mt-24"></a>
            <p class="font-bold mb-3">{sub.head}</p>
            {sub.image && <img src={'/img/faq/'+this.$i18n.locale+'/'+sub.image} class="w-full mb-3" />}
            <p domPropsInnerHTML={sub.body}></p>
            </div>
          ))}
          </div>
          }
          {faq.type === 'stacked' &&
          faq.subcategories.map((sub) => (
          <div class="flex flex-1 flex-col lg:flex-row-reverse mb-5 text-sm lg:text-base ">
            <p class="lg:hidden font-bold">{sub.head}</p>
            {sub.image && <img src={'/img/faq/'+this.$i18n.locale+'/'+sub.image} class="lg:w-1/2 my-3 lg:ml-8" />}
            <div class={sub.image && 'lg:w-1/2'}>
            <a name={faq.slug+'-'+sub.slug} class="block pt-24 -mt-24"></a>
              <p class="hidden lg:block font-bold mb-4">
              {sub.head}
              </p>
              <p domPropsInnerHTML={sub.body}></p>
            </div>
          </div>
          ))}
          {faq.type === 'double-stacked' &&
          <div class="flex flex-col flex-1 text-sm lg:text-base mt-8">
          {faq.subcategories.map((sub) => (
          <div class="flex flex-1 flex-col lg:flex-row mb-5">
            <div class="lg:w-1/2">
            <a name={faq.slug+'-'+sub.slug} class="block pt-24 -mt-24"></a>
            <p class="font-bold mb-4">{sub.head}</p>
            <p domPropsInnerHTML={sub.body}></p>
            </div>
            {sub.hiddenimage1 && <img src={'/img/faq/'+this.$i18n.locale+'/'+sub.hiddenimage1} class="my-3 lg:hidden" />}
            {sub.image && <img src={'/img/faq/'+this.$i18n.locale+'/'+sub.image} class="lg:w-1/2 my-3 lg:ml-8" />}
            {sub.hiddenimage2 && <img src={'/img/faq/'+this.$i18n.locale+'/'+sub.hiddenimage2} class="my-3 lg:hidden" />}
          </div>
          ))}
          </div>
          }
        </div>
        ))

    return (
      <PageTemplate>
        <div class="bg-secondary">
          <div class="container mx-auto px-3 lg:px-6 py-2 lg:py-3">
            <h1 class="text-2xl lg:text-3xl text-white">
              {this.$t("help_page.h1")}
            </h1>
          </div>
        </div>
        <div class="bg-secondary_light">
          <div class="container mx-auto px-3 lg:px-6 py-3 lg:py-5">
          <h3 class="text-lg lg:text-2xl text-blue-600 font-bold">
              {this.$t("help_page.frequently_asked_questions")}
            </h3>
          </div>
        </div>
        <div class="pt-4">
          <div class="container mx-auto px-3 lg:px-6">
            
            {TopLinks}
            {FaqItems}
          </div>
        </div>
      </PageTemplate>
    );
  },
};

/**
 *
 * @type {{data(): *, methods: {toggle(): void}, render(*): *, props: string[]}}
 */
const Collapse = {
  props: ["head", "body", "first"],

  data() {
    return { open: false };
  },

  methods: {
    toggle() {
      this.open = !this.open;
    },
  },

  render(h) {
    const icnClass = classNames("mdi text-blue-600 mr-3 leading-tight", {
      "mdi-plus-circle-outline": !this.open,
      "mdi-minus-circle-outline": this.open,
    });

    const eleClass = classNames("border-gray-200 border-t-4 py-6 lg:py-6", {
      "lg:border-0": this.first,
    });

    return (
      <div class={eleClass}>
        <div
          class="flex lg:items-center cursor-pointer select-none"
          onClick={this.toggle}
        >
          <i class={icnClass}></i>
          <p class="font-bold text-sm lg:text-base">{this.head}</p>
        </div>
        {this.open && (
          <p
            class="text-xs lg:text-sm lg:w-9/12 py-3"
            domPropsInnerHTML={this.body}
          ></p>
        )}
      </div>
    );
  },
};
